module.exports = __webpack_public_path__ + "static/media/anon.70836822.png";